module.exports = __webpack_public_path__ + "static/media/innowind-trends-bannerimg.8112edc6.jpg";